import { Notify } from "quasar";
import { useReLogin } from "@/services/useAuth";
import { useRouter } from "@/routing/router";
import { notifies } from "@/services/useLocales";

export class NotAuthorizedError extends Error {
  constructor(...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotAuthorizedError);
    }

    this.name = "NotAuthorizedError";
  }
}

export const handleError = async (e, { notify } = { notify: true }) => {
  let message = "Неизвестная ошибка. Обратитесь к администратору";

  const errorContent = e?.response?.data?.errors;
  const errorStatus = e?.response?.status;

  if (errorContent?.length && typeof errorContent !== "string") {
    message = errorContent[0];
  } else if (typeof errorContent === "string") {
    message = errorContent;
  }

  if (e?.name === "NotAuthorizedError" || errorStatus === 403) {
    const router = useRouter();

    message = notifies.value.access_error;
    Notify.create({ badgeStyle: "display: none;", message });

    router.push("/");
  }

  if (errorStatus !== 401 && notify) {
    Notify.create({ badgeStyle: "display: none;", message });
  }

  await useReLogin(e?.response?.status);

  console.error(message);
};
